import React from 'react';
import { Text } from '@mantine/core';
import AudioComponent from '../../body/AudioComponent';
import { pdfFiles, PDFdownloadButton } from '../../body/Pdf';
import VideoSlide from '../../body/VideoSlide';

const SayWhatYouMean = () => {
  return (
    <div className='text-left p-4 space-y-6'>
      <VideoSlide vidSrc={1195765602}></VideoSlide>;
    </div>
  );
};

export default SayWhatYouMean;
